// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1dKeb","overflowing":"ReadFullNote_overflowing__2MdoL"};